/* globals cpac, $, showResources, $j */

if (typeof cpac !== 'undefined') {
  cpac.accounting = cpac.accounting || {};
  cpac.accounting.statement = {
      print: function( baseUrl ){
          var data = $('filterForm').serialize();
          var form = $('monthToPrintForm');
          form.action = baseUrl + 'accounting/statement?&print=1&' + data;
          form.target='_blank';
          form.method='post';
          form.submit();
      },
      email: function (baseUrl, form) {
          var formData = form.serialize();
  
          var url = baseUrl + 'accounting/invoice?as_pdf=1&toolEmail=1'; //'accounting/invoice-print?&as_pdf=1&download=1&toolEmail=1';
          showResources($('filterForm'), url, 'message_container', null, formData);
      },
  
      pdf: function(baseUrl, form){
          var formData = form.serialize();
          var data = $('filterForm').serialize();
          form.attr('action', baseUrl + 'accounting/invoice?as_pdf=1&' + data + '&' + formData); //'accounting/invoice-print?&as_pdf=1&download=1&' + data;
          form.attr('target', '_blank');
          form.attr('method', 'post');
          form.submit();
      }
  }

  cpac.accounting.enableAllCheckboxes = function (parent_id, checkbox_name) {
    var isChecked = $j('#' + checkbox_name).prop('checked') ? true : false;

    var checkboxes = $j('#' + parent_id + ' .checkbox');
    $j.each(checkboxes, function (i, val) {
        var el = $j(val);
        var elIsChecked = el.prop('checked') ? true : false;
        if (elIsChecked != isChecked) {
            el.click();
        }
    });
  };

  /**
   *
   * @param text
   * @param positiveOnly
   * @returns {Number}
   */
  cpac.accounting.getAmountValue = function (text, positiveOnly) {
      var value = parseFloat(text.replace('$', ''));
      if (isNaN(value)) {
          value = 0;
      }

      if (positiveOnly && value < 0) {
          value = 0;
      }

      return value;
  };



  cpac.accounting.batchList = {
      postBatch: function() {
          var check_value = $j('#batches_form tr input[type="checkbox"]:checked').map(function (){
              return this.value;
          }).get();
          if(check_value == ''){
              $j.caAlert('Please select at least one batch for closing.');
              return false;
          }
          var onConfirm = function () {
              $j('#batches_form').find('#post_batches').val('1');
              $j('#batches_form').submit();
              $j('#batches_form').find('#post_batches').val('0');
          }

          $j.caConfirm('Are you sure you want to post selected batches?', 'Post Batch Confirmation', 'Post Batches', 'Cancel', onConfirm);
      }
  }

  cpac.accounting.batch = {
      timer: null,
      lastSearch: null,

      onSearchKeywordDTR: function ( sender , renew ) {
          var inputVal = $j(sender).val();

          clearTimeout( this.timer );

          if( this.lastSearch == inputVal && (typeof(renew) == 'undefined' || !renew)) {
              return;
          }
          this.timer = setTimeout( function(){

              cpac.accounting.batch.doFilterTable( inputVal );
              cpac.accounting.batch.lastSearch = inputVal;
          }, 1000 );
      },

      doFilterTable: function( inputVal ) {
          var id = 0;

          var rows = [];
          var content = '';

          if( ! inputVal ) {
              inputVal = $j('#keyword_input').val();
          }

          if( ! inputVal || inputVal == 'Keyword search' ) {
              $j('#reports_table tr').show();
              return;
          }

          var _showHide = function() {
              var re = new RegExp( inputVal, 'gi')
              content = content.replace(/<\/?[^>]+(>|$)/g, ' ');

              if( re.test( content )) {
                  $j.each(rows, function(i,row) {
                      row.style.display = '';
                  });
              } else {
                  $j.each(rows, function(i,row) {
                      row.style.display = 'none';
                  });
              }
          }

          $j('#reports_table tr').each(function(i, row){
              var jr = $j(row);

              if( jr.hasClass('transaction_row')) {
                  var tid = jr.attr('id');

                  if( /[0-9]+$/.test(tid)) {
                      _showHide();
                      content = '';
                      rows = [];
                      id = tid;
                      content += jr.children()[3].innerHTML+' ';
                      content += jr.children()[4].innerHTML+' ';
                      content += jr.children()[5].innerHTML + ' ';
                  }
              }
              else return;

              rows.push( row );
          });
          _showHide();
      },

      postBatch: function() {

          var url = $j('#filter_form').attr('action');
          var data = $j('#filter_form').serialize() + '&' + $j('#post_batch_form').serialize() + '&post_batch=1';

          var callback = function (response) {
              cpac.accounting.batch.hidePostBatchProgress();

              $j('#report-parent-container').html(response);
          };

          cpac.accounting.batch.showPostBatchProgress();
          $j.caPost(url, data, callback);
      },

      showPostBatchProgress: function() {

      },

      hidePostBatchProgress: function() {

      }
  }

  cpac.accounting.charge = {
      _formId: '',
      _form: null,
      _taxRates: null,
      _changed: false,

      _count: 0,
      _pricePerUnit: 0,
      _amount: 0,
      _discountableAmount: 0,
      _discount: {'type':'$', 'inputValue': 0, 'amount': 0},
      _new_discount: {'type':'$', 'inputValue': 0, 'amount': 0},
      _order_discount: {'type':'$', 'inputValue': 0, 'amount': 0},
      _taxableAmount: 0,
      _tax: {'rate_id': 0, 'rate_value': 0, 'amount': 0},
      _total: 0,

      _totalPaid: 0,
      _accountCredit: 0,

      addTaxRate: function(rateId, rateValue) {
          if (this._taxRates == null) {
              this._taxRates = new Array();
          }
          this._taxRates[rateId] = parseFloat(rateValue);
          if (isNaN(this._taxRates[rateId])) {
              this._taxRates[rateId] = 0;
          }
      },

      getTaxRate: function(rateId) {
          if (this._taxRates == null) {
              this._taxRates = new Array();
          }

          if (typeof(this._taxRates[rateId]) == 'undefined') {
              return 0;
          }
          return this._taxRates[rateId];
      },

      init: function(formId) {
          this._formId = formId;
          this._form = $j('#' + this._formId);
          this._taxRates = new Array();
          this._totalPaid = 0;
          this._accountCredit = 0;
          this._changed = false;
      },

      setChanged: function(value) {
          this._changed = value ? true : false;
      },

      setTotalPaid: function(totalPaid) {
          this._totalPaid = parseFloat(totalPaid);
          if (isNaN(this._totalPaid) || this._totalPaid < 0) {
              this._totalPaid = 0;
          }
      },

      recalculateTotal: function() {
          this.updateAmount();
          this.updateDiscounts();
          this.updateTax();
          this.updateTotal();
          this.updateAccountCredit();
      },

      onsubmitForm: function() {
          this.recalculateTotal();
          if (this._accountCredit > 0) {
              var formEl = this._form;

              var onYes = function() {
                  formEl.get(0).submit();
              }

              var text = "Charge amount has been reduced. A new “Account Credit” payment line will be added to the statement and batch. Are you sure you want to continue saving?";

              $j.caConfirm (text, 'Confirm', 'Yes', 'Cancel', onYes)

              return false;   // do not submit the form right away
          }

          return true;
      },

      updateAmount: function() {
          this._calculateAmount();
          this._form.find('#charge-amount').text('$' + this._amount.toFixed(2));
      },


      _calculateAmount: function() {
          this._count = parseFloat(this._form.find('#count').val());
          if (isNaN(this._count) || this._count < 0) {
              this._count = 0;
          }

          this._pricePerUnit = cpac.accounting.getAmountValue(this._form.find('#price_per_unit').val(), true);

          this._amount = Math.round(this._count * this._pricePerUnit * 100) / 100;
          this._discountableAmount = this._amount;
      },

      updateDiscounts: function() {
          this._calculateDiscount(this._discount, 'discount');
          this._calculateDiscount(this._new_discount, 'new_discount');
          this._calculateDiscount(this._order_discount, 'order_discount');
      },

      _calculateDiscount: function(discount, name) {
          discount.type = this._form.find('#' + name + '_type').val();
          discount.inputValue = parseFloat(this._form.find('#' + name + '').val());
          if (isNaN(discount.inputValue) || discount.inputValue < 0) {
              discount.inputValue = 0;
          }
          if (discount.type == '%') {
              discount.amount = Math.round(discount.inputValue * this._discountableAmount) / 100;
          } else {
              discount.amount = discount.inputValue;
          }
          this._discountableAmount = this._discountableAmount - discount.amount;
      },

      updateTax: function() {
          this._calculateTax();
          this._form.find('#tax').val(this._tax.amount.toFixed(2));
      },

      _calculateTax: function() {
          this._calculateTaxableAmount();
          this._tax.rate_id = this._form.find('#tax_rate_id').val();
          this._tax.rate = this.getTaxRate(this._tax.rate_id);
          this._tax.amount = Math.round(this._taxableAmount * this._tax.rate) / 100;
      },

      _calculateTaxableAmount: function() {
          this._taxableAmount = this._amount - this._discount.amount - this._new_discount.amount - this._order_discount.amount;
          if (isNaN(this._taxableAmount) || this._taxableAmount < 0) {
              this._taxableAmount = 0;
          }
      },

      updateTotal: function() {
          this._calculateTotal();
          this._form.find('#charge-total').text('$' + this._total.toFixed(2));
      },

      _calculateTotal: function() {
          this._total = Math.round(100 * (this._taxableAmount + this._tax.amount)) / 100;
      },

      updateAccountCredit: function() {
          this._calculateAccountCredit();
          this._form.find('#account_credit_amount').text('$' + this._accountCredit.toFixed(2));
          if (this._accountCredit > 0) {
              this._form.find('#account_credit_row').show();
          } else {
              this._form.find('#account_credit_row').hide();
          }
      },

      _calculateAccountCredit: function() {
          this._accountCredit = this._totalPaid - this._total;
          if (isNaN(this._accountCredit) || this._accountCredit < 0) {
              this._accountCredit = 0;
          }
      },

      onApplyCreditClick: function(formBtn) {
          var title  = this._changed ? 'Save and apply credit?' : 'Apply credit?';
          var text = this._changed ?
              "You have made changes to the transaction. Are you sure you want to save it and apply credits?" :
              "Are you sure you want to apply credits?";

          $j.caConfirm(
              text,
              title,
              'Yes, Proceed',
              'Cancel',
              function() {
                  formBtn.form.apply_marker.value = '1';
                  formBtn.form.submit();
              },
              function() { return false; }
          );


      },

      onCancelPackagePaymentClick: function(ptansactioinId) {
          var title = 'Return payment to package';
          var text = 'Are you sure you want to return this payment to the package?';

          var that = this;

          $j.caConfirm(
              text,
              title,
              'Yes, Proceed',
              'Cancel',
              function() {
                  var _form = that._form.get(0);
                  _form.cancel_payment.value = ptansactioinId;
                  _form.save.value = '0';
                  _form.submit();
              },
              function() { return false; }
          );
      },

      clearMember: function() {
          $j('.available_credit').html('');
      },

      onMemberChange: function() {
          //TODO: show available credit for this user
      },

      onDelBtnClick: function () {
          cpac.accounting.charge._form.find('#delete_marker').val('1');
          cpac.accounting.charge._form.submit();
      },

      onRevBtnClick: function () {
          cpac.accounting.charge._form.find('#reverse_marker').val('1');
          cpac.accounting.charge._form.submit();
      }
    }

    cpac.accounting.payment = {
      _formId: '',
      _form: null,
      _chargesListId: 'payment_charges',
      _chargesList: [],
      _chargesListKeys: {},
      _errorFieldClass: 'ca-error-field',
      _maxPaymentAmount: -1,
      _maxAmountNoLimit: -1,

      _amount: 0,

      _totalPaid: 0,
      _creditAmount: 0,
      _refundedCredit: 0,
      _isReverse: false,

      init: function(formId) {
          this._formId = formId;
          this._form = $j('#' + this._formId);

          this._loadRefundedCredit();
      },

      clearMember: function() {
          $j('#' + this._chargesListId).html('');

          cpac.accounting.payment.clearCharges();
          cpac.accounting.payment.updateCreditAmount();
      },

      onMemberChange: function() {
          $j.caPostToDiv(
              this._form.attr('action'),
              $j(this._form).serialize() + '&view_charges=1',
              '#' + this._chargesListId,
              function() {
                  cpac.accounting.payment.loadCharges();
                  cpac.accounting.payment.updateCreditAmount();
              }
          );
      },

      updateAmount: function() {
          if (this._isReverse) {
              this._updateReversedAmount();
          } else {
              this._loadAmount();
              this._form.find('#amount').val('$' + this._amount.toFixed(2));
          }
      },

      updateCheckNumber: function (value_id) {
          if ($j('#type_id').val() == value_id) {
              $j('#check_number_div').show();
          }
          else {
              $j('#check_number_div').hide();
          }
      },
      
      updateAccountingGroup: function (selectedType) {
          if ($j('#type_id').val() == selectedType) {
              $j('.set-accounting-group').show();
          } else {
              $j('.set-accounting-group').hide();
          }
      },

      onPaymentChange: function(valueId) {
          this.updateCheckNumber(valueId);

          if ($j('#transaction').val() === '') {
              var typeId = $j('#type_id').val();
              var typeName = $j('#type_id option:selected').text();

              if (typeId > 0 && typeName) {
                  $j('#description').val('Custom Payment: ' + typeName);
              } else {
                  $j('#description').val('');
              }
          }
      },

      _loadAmount: function() {
          var amountField = this._form.find('#amount');
          this._amount = cpac.accounting.getAmountValue(amountField.val(), true);
          if (this._maxPaymentAmount == this._maxAmountNoLimit) {
              if (amountField.attr('max_amount') != undefined) {
                  this._maxPaymentAmount = cpac.accounting.getAmountValue(amountField.attr('max_amount'), true);
              } else {
                  this._maxPaymentAmount = this._maxAmountNoLimit;
              }
          }
          if (this._maxPaymentAmount != this._maxAmountNoLimit &&
              this._amount > this._maxPaymentAmount) {
              this._amount = this._maxPaymentAmount;
              this.animateError(amountField.parent());
          }
      },

      _loadRefundedCredit: function() {
          var refundedField = this._form.find('#refunded_credit');
          this._refundedCredit = cpac.accounting.getAmountValue(refundedField.val(), true);
      },

      clearCharges: function() {
          this._chargesList = [];
          this._chargesListKeys = {};
          this._totalPaid = 0;
      },

      loadCharges: function() {
          this.clearCharges();

          var trList = $j('#' + this._chargesListId).find('table tr');
          $j.each(trList, function(i, tr) {
              cpac.accounting.payment.updateChargeData(tr);
          });
      },

      updateChargeData: function (trRow) {
          var trObj = $j(trRow);
          var chargeId = trObj.attr('charge_id');

          if (typeof(chargeId) == 'undefined') {
              return;
          }

          var chargeRow = {
              'id': chargeId,
              'selected': trObj.find('#payment_charges-' + chargeId + '-selected').is(':checked') ? 1 : 0,
              'amount': cpac.accounting.getAmountValue(trObj.find('#payment_charges-' + chargeId + '-amount').val(), true),
              'unpaid_amount': cpac.accounting.getAmountValue(trObj.find('#payment_charges-' + chargeId + '-unpaid_amount').val(), true),
              'original_amount': cpac.accounting.getAmountValue(trObj.find('#original_amount_' + chargeId).text(), true),
              'open_balance': cpac.accounting.getAmountValue(trObj.find('#open_balance_' + chargeId).text(), true),
              'amount_error' : false
          };

          if (typeof(this._chargesListKeys[chargeId]) != 'undefined') {
              // charge already exists -- update
              this._chargesList[this._chargesListKeys[chargeId]] = chargeRow;
          } else {
              this._chargesList.push(chargeRow);
              this._chargesListKeys[chargeRow.id] = this._chargesList.length - 1;
          }


          return chargeRow;
      },

      updateCreditAmount: function() {
          if (this._isReverse) {
              return this._updateReversedAmount();
          }
          this._calculateCreditAmount();
          this._form.find('#acc_credit').text('$' + this._creditAmount.toFixed(2));
          this._form.find('#credit_amount').val(this._creditAmount.toFixed(2));
      },

      _calculateCreditAmount: function() {
          this._calculateTotalPaid();

          this._creditAmount = Math.round(100 * (this._amount - this._totalPaid - this._refundedCredit)) / 100;
          if (this._creditAmount < 0) {
              this._creditAmount = 0;
          }
      },

      _calculateTotalPaid: function() {
          this._totalPaid = 0;

          var that = this;

          $j.each(this._chargesList, function (i, chargeRow) {
              that._totalPaid = that._totalPaid + chargeRow.amount
          });
      },

      onChargeSelectChange: function(trRow) {
          var chargeRow = this.updateChargeData(trRow);

          if (!chargeRow) {
              return;
          }

          if (!chargeRow.selected) {
              this.unselectCharge(chargeRow);
          } else {
              this.selectCharge(chargeRow);
          }
      },

      unselectCharge: function(chargeRow) {
          chargeRow.selected = 0;

          if (0 != chargeRow.amount) {
              chargeRow.open_balance = chargeRow.unpaid_amount;
              chargeRow.amount = 0;
          }

          this.updateChargeRow(chargeRow);
          this.updateCreditAmount();

      },

      selectCharge: function(chargeRow) {
          chargeRow.selected = 1;
          if (0 == chargeRow.amount) {
              if (this._isReverse) {
                  chargeRow.amount = chargeRow.open_balance;
              } else {
                  chargeRow.amount = Math.min(this._creditAmount, chargeRow.open_balance);
              }

              chargeRow.open_balance = chargeRow.unpaid_amount - chargeRow.amount;

              if (0 == chargeRow.amount) {
                  return this.unselectCharge(chargeRow);
              }
          }

          this.updateChargeRow(chargeRow);
          this.updateCreditAmount();
      },

      onChargeChangeAmount: function(trRow) {
          var chargeRow = this.updateChargeData(trRow);

          if (!chargeRow) {
              return;
          }

          chargeRow.amount_error = false;

          if (chargeRow.amount > 0) {
              // check amount
              if (chargeRow.amount > chargeRow.unpaid_amount) {
                  chargeRow.amount = chargeRow.unpaid_amount;
                  chargeRow.amount_error = true;
              }

              this._calculateTotalPaid();
              if (!this._isReverse) {
                  if (this._totalPaid > this._amount) {
                      var diff = this._totalPaid - this._amount;
                      chargeRow.amount -= diff;
                      chargeRow.amount_error = true;
                      if (chargeRow.amount < 0) {
                          chargeRow.amount = 0;
                      }
                  }
              }
          }


          chargeRow.open_balance = chargeRow.unpaid_amount - chargeRow.amount;

          if (chargeRow.amount > 0) {
              this.selectCharge(chargeRow);
          } else {
              this.unselectCharge(chargeRow);
          }
      },


      updateChargeRow: function(chargeRow) {
          var trRow = this._form.find('tr[charge_id="' + chargeRow.id + '"]');

          if (!trRow) {
              return;
          }

          var chargeId = chargeRow.id;

          // update checkbox
          var selectObj = trRow.find('#payment_charges-' + chargeId + '-selected');

          if (chargeRow.selected) {
              if (!selectObj.is(':checked')) {
                  selectObj.prop('checked', true);
                  selectObj.prev().val(1);
              }
          } else {
              if (selectObj.is(':checked')) {
                  selectObj.prop('checked', false);
                  selectObj.prev().val(0);
              }
          }

          if (chargeRow.amount_error) {
                  // animate error
              this.animateError(trRow.find('#payment_charges-' + chargeId + '-amount').parent());
          } else {
              trRow.find('#payment_charges-' + chargeId + '-amount').parent().removeClass(this._errorFieldClass);
          }

          // update open balance
          trRow.find('#open_balance_' + chargeId).text('$' + chargeRow.open_balance.toFixed(2))

          // update amount
          trRow.find('#payment_charges-' + chargeId + '-amount').val(chargeRow.amount.toFixed(2));
      },

      animateError: function (tdObj) {
          tdObj.addClass(this._errorFieldClass)
              .removeClass(this._errorFieldClass, 200)
              .addClass(this._errorFieldClass, 200)
              .removeClass(this._errorFieldClass, 200);

      },

      onChangePaymentAmount: function() {
          this.updateAmount();
          this.updateCreditAmount();
          this._updatePaymentsAmount();
      },

      _updatePaymentsAmount: function() {
          if (this._amount < this._totalPaid) {
              var diff = 0;

              // paid too much, need to reduce one or more payments (starting from the bottom)
              diff = this._totalPaid - this._amount;
              var that = this;

              var tmpArray = this._chargesList.slice(0); // need to make a copy of charges list, otherwise it messes up the keys

              $j.each(tmpArray.reverse(), function(i, chargeTmp) {
                  var chargeRowKey = that._chargesListKeys[chargeTmp.id];
                  var chargeRow = typeof(chargeRowKey) != 'undefined' ? that._chargesList[chargeRowKey] : null;

                  if (chargeRow && chargeRow.amount > 0) {
                      var deductAmount = Math.min(diff, chargeRow.amount);
                      if (deductAmount > 0) {
                          // reduce payment amount for this charge

                          chargeRow.amount -= deductAmount;
                          chargeRow.open_balance = chargeRow.unpaid_amount - chargeRow.amount;
                          diff -= deductAmount;

                          if (chargeRow.amount <= 0) {
                              // charge become fully unpaid -- un-select
                              that.unselectCharge(chargeRow);
                          } else {
                              that.updateChargeRow(chargeRow);
                          }
                      }

                      if (diff <= 0) {
                          return false; // break
                      }
                  }
              });

              this.updateCreditAmount(); // this will also update totalPaid amount
          }
      },

      onDelBtnClick: function () {
          cpac.accounting.payment._form.find('#delete_marker').val('1');
          cpac.accounting.payment._form.submit();
      },

      setIsReverse: function(value) {
          this._isReverse = value;
      },

      _updateReversedAmount: function() {
          this._calculateTotalPaid();

          this._form.find('#reverse_amount').text('$' + this._totalPaid.toFixed(2));
          this._form.find('#amount').val(this._totalPaid.toFixed(2));
      }
  }

}